/* ============================================
   Zelatonin 2026 1.0.0 — Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Scroll Reveal Animation --- */
  function initReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10px 0px' });
    reveals.forEach(function(el) { observer.observe(el); });
  }

  /* --- CountUp Animation --- */
  function initCountUp() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-count'));
          var decimals = parseInt(el.getAttribute('data-decimals') || '0');
          var suffix = el.getAttribute('data-suffix') || '';
          var duration = 2000;
          var steps = 60;
          var increment = target / steps;
          var current = 0;
          var timer = setInterval(function() {
            current += increment;
            if (current >= target) {
              current = target;
              clearInterval(timer);
            }
            el.textContent = (decimals > 0 ? current.toFixed(decimals) : Math.floor(current).toLocaleString()) + suffix;
          }, duration / steps);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function(el) { observer.observe(el); });
  }

  /* --- Floating Particles (Hero) --- */
  function initParticles() {
    var container = document.getElementById('hero-particles');
    if (!container) return;
    for (var i = 0; i < 20; i++) {
      var p = document.createElement('div');
      p.className = 'hero__particle animate-float';
      var size = Math.random() * 4 + 2;
      p.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (Math.random() * 100) + '%;top:' + (Math.random() * 100) + '%;animation-delay:' + (Math.random() * 6) + 's;animation-duration:' + (Math.random() * 4 + 4) + 's;';
      container.appendChild(p);
    }
  }

  /* --- Cart Drawer --- */
  function initCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    var closeBtn = document.getElementById('cart-close');
    var openBtns = document.querySelectorAll('[data-open-cart]');

    if (!drawer) return;

    function openCart() {
      overlay.classList.add('active');
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      overlay.classList.remove('active');
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openCart); });
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);

    window.openCartDrawer = openCart;
    window.closeCartDrawer = closeCart;
  }

  /* --- Cart AJAX --- */
  var cartUpdatePending = false;
  window.updateCartItem = function(key, qty) {
    if (cartUpdatePending) return;
    cartUpdatePending = true;
    var page = document.querySelector('[data-cart-page]');
    var sectionId = page && page.dataset.sectionId;
    var payload = { id: key, quantity: qty };
    if (sectionId) {
      payload.sections = [sectionId];
      payload.sections_url = window.location.pathname;
      page.setAttribute('aria-busy', 'true');
    }
    document.querySelectorAll('[data-cart-page] button, #cart-items button').forEach(function(button) {
      button.disabled = true;
    });
    return fetch(window.Zelatonin.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    })
    .then(function(cart) {
      if (typeof cart.item_count !== 'number') throw new Error('Invalid cart response');
      refreshCartDrawer(cart);
      if (!page) return;
      var html = cart.sections && cart.sections[sectionId];
      var next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
      if (!next) {
        window.location.reload();
        return;
      }
      next.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); });
      page.replaceWith(next);
    })
    .catch(function() {
      // Reload authoritative cart state without retrying the mutation.
      window.location.reload();
    })
    .finally(function() {
      cartUpdatePending = false;
      var currentPage = document.querySelector('[data-cart-page]');
      if (currentPage) currentPage.removeAttribute('aria-busy');
      document.querySelectorAll('[data-cart-page] button, #cart-items button').forEach(function(button) {
        button.disabled = false;
      });
    });
  };

  window.addToCart = function(variantId, qty) {
    fetch(window.Zelatonin.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetch(window.Zelatonin.routes.cartGet, { headers: { 'Content-Type': 'application/json' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      refreshCartDrawer(cart);
      if (window.Zelatonin.cartType === 'drawer') {
        window.openCartDrawer();
      }
    });
  };

  function refreshCartDrawer(cart) {
    var countEl = document.getElementById('cart-count');
    var subtotalEl = document.getElementById('cart-subtotal');
    var itemsEl = document.getElementById('cart-items');
    var headerCounts = document.querySelectorAll('.header__cart-count');

    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    headerCounts.forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>' + (window.Zelatonin.strings.cartEmpty || 'Your cart is empty') + '</p></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-drawer__item" data-key="' + item.key + '">';
      html += '<div class="cart-drawer__item-image">';
      if (item.image) {
        html += '<img src="' + getSizedImage(item.image, '160x') + '" alt="' + escapeHtml(item.title) + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="cart-drawer__item-details">';
      html += '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>';
      html += '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<div class="cart-drawer__item-qty">';
      html += '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="' + (window.Zelatonin.strings.decrease || 'Decrease') + '">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="' + (window.Zelatonin.strings.increase || 'Increase') + '">+</button>';
      html += '</div>';
      html += '<button class="cart-drawer__item-remove" onclick="updateCartItem(\'' + item.key + '\',0)">' + (window.Zelatonin.strings.remove || 'Remove') + '</button>';
      html += '</div></div>';
    });
    itemsEl.innerHTML = html;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountWithComma = amount.replace('.', ',');
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountNoDecimalsWithComma = amountNoDecimals;
    var format = window.Zelatonin.moneyFormat || '€{{amount}}';

    /* Theme setting override: force dot or comma regardless of store format */
    var useDot = window.Zelatonin.priceFormat === 'dot';
    var result = format
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
      .replace('{{amount_with_apostrophe_separator}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);

    if (useDot) {
      /* Convert comma decimals to dot: €21,99 → €21.99 */
      result = result.replace(/(\d),(\d{2})(?!\d)/g, '$1.$2');
    }
    return result;
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* --- Age Gate --- */
  function initAgeGate() {
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    if (localStorage.getItem('zelatonin_age_verified') === 'true') {
      gate.classList.add('hidden');
      return;
    }

    var yesBtn = document.getElementById('age-gate-yes');
    var noBtn = document.getElementById('age-gate-no');
    var denied = document.getElementById('age-gate-denied');
    var buttons = document.getElementById('age-gate-buttons');

    if (yesBtn) yesBtn.addEventListener('click', function() {
      localStorage.setItem('zelatonin_age_verified', 'true');
      gate.classList.add('hidden');
    });

    if (noBtn) noBtn.addEventListener('click', function() {
      if (buttons) buttons.style.display = 'none';
      if (denied) denied.classList.remove('hidden');
    });
  }

  /* --- Discount Popup --- */
  /* --- Mobile Menu --- */
  function initMobileMenu() {
    var overlay = document.getElementById('mobile-overlay');
    var menu = document.getElementById('mobile-menu');
    var openBtn = document.querySelector('[data-open-mobile-menu]');
    var closeBtn = document.getElementById('mobile-close');

    if (!menu) return;

    function open() {
      overlay.classList.add('active');
      menu.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('active');
      menu.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    menu.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', close); });
  }

  /* --- FAQ Accordion --- */
  function initFAQ() {
    document.querySelectorAll('.faq-item__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.closest('.faq-item');
        var content = item.querySelector('.faq-item__content');
        var isOpen = item.hasAttribute('open');

        // Close others
        document.querySelectorAll('.faq-item[open]').forEach(function(other) {
          if (other !== item) {
            other.removeAttribute('open');
            var otherContent = other.querySelector('.faq-item__content');
            if (otherContent) otherContent.style.maxHeight = '0';
          }
        });

        if (isOpen) {
          content.style.maxHeight = '0';
          setTimeout(function() { item.removeAttribute('open'); }, 300);
        } else {
          item.setAttribute('open', '');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // Init: set max-height to 0 for all closed items
    document.querySelectorAll('.faq-item:not([open]) .faq-item__content').forEach(function(c) {
      c.style.maxHeight = '0';
      c.style.overflow = 'hidden';
      c.style.transition = 'max-height 0.3s ease';
    });
  }

  /* --- Product Page Quantity --- */
  function initProductForm() {
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    var qtyDisplay = document.querySelector('[data-qty-value]');
    var qtyHidden = document.getElementById('product-qty-input');

    function syncQty(val) {
      if (qtyDisplay) qtyDisplay.textContent = val;
      if (qtyHidden) qtyHidden.value = val;
    }

    if (minusBtn && qtyDisplay) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyDisplay.textContent) || 1;
        if (val > 1) syncQty(val - 1);
      });
    }
    if (plusBtn && qtyDisplay) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyDisplay.textContent) || 1;
        syncQty(val + 1);
      });
    }

    var addBtn = document.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        var action = this.getAttribute('data-action') || 'add_to_cart';
        var qty = parseInt((qtyDisplay && qtyDisplay.textContent) || '1');
        if (!variantId) return;

        fetch(window.Zelatonin.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (action === 'buy_now') {
            window.location.href = '/checkout';
          } else {
            return fetch(window.Zelatonin.routes.cartGet, { headers: { 'Content-Type': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                refreshCartDrawer(cart);
                if (window.Zelatonin.cartType === 'drawer') {
                  window.openCartDrawer();
                }
              });
          }
        });
      });
    }
  }

  /* --- Parallax Background --- */
  function initParallax() {
    var bgs = document.querySelectorAll('.section-bg--parallax');
    if (!bgs.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function update() {
      var windowH = window.innerHeight;
      bgs.forEach(function(bg) {
        var section = bg.parentElement;
        var rect = section.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > windowH + 100) return;
        var progress = (windowH - rect.top) / (windowH + rect.height);
        var img = bg.querySelector('img');
        if (!img) return;
        var shift = (progress - 0.5) * 15;
        img.style.transform = 'translate3d(0,' + shift + '%,0) scale(1.02)';
      });
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  /* --- Marquee seamless loop --- */
  function initMarquee() {
    document.querySelectorAll('.marquee-track').forEach(function(track) {
      var firstSet = track.querySelector('.marquee-set');
      if (!firstSet) return;
      function measure() {
        var w = firstSet.offsetWidth;
        track.style.setProperty('--marquee-shift', '-' + w + 'px');
      }
      measure();
      window.addEventListener('resize', measure);
    });
  }

  /* --- Sleep Clock Pill --- */
  function initSleepClockPill() {
    var pill = document.getElementById('sleep-pill');
    if (!pill) return;
    var dismissed = localStorage.getItem('zelatonin_pill_dismissed');
    if (dismissed) { pill.classList.add('hidden'); return; }
    var msgs = window.Zelatonin.pillMessages || [];
    function update() {
      var now = new Date();
      var h = now.getHours();
      var timeEl = document.getElementById('sleep-pill-time');
      var msgEl = document.getElementById('sleep-pill-msg');
      if (timeEl) timeEl.textContent = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }).toLowerCase();
      var msg = '';
      if (h >= 5 && h < 8) msg = msgs[0] || '';
      else if (h >= 8 && h < 18) msg = msgs[1] || '';
      else if (h >= 18 && h < 21) msg = msgs[2] || '';
      else if (h >= 21 && h < 23) msg = msgs[3] || '';
      else if (h >= 23 || h < 1) msg = msgs[4] || '';
      else if (h >= 1 && h < 3) msg = msgs[5] || '';
      else msg = msgs[6] || '';
      if (msgEl) msgEl.innerHTML = msg;
      if (pill.dataset.pulse === 'true' && h >= 21 && h < 23) {
        pill.classList.add('sleep-pill--pulsing');
      } else {
        pill.classList.remove('sleep-pill--pulsing');
      }
    }
    update();
    setInterval(update, 60000);
    var closeBtn = document.getElementById('sleep-pill-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        pill.classList.add('hidden');
        localStorage.setItem('zelatonin_pill_dismissed', Date.now().toString());
      });
    }
  }

  /* --- Sleep Quiz --- */
  function initSleepQuiz() {
    var intro = document.getElementById('quiz-intro');
    var questionsWrap = document.getElementById('quiz-questions');
    var resultsWrap = document.getElementById('quiz-results');
    if (!intro || !questionsWrap) return;

    var startBtn = document.getElementById('quiz-start');
    var steps = questionsWrap.querySelectorAll('.quiz__step');
    var progressFill = document.getElementById('quiz-progress-fill');
    var progressText = document.getElementById('quiz-progress-text');
    var totalSteps = steps.length;
    var currentStep = 0;
    var scores = [];

    function showStep(index) {
      steps.forEach(function(s) { s.classList.add('hidden'); });
      if (steps[index]) steps[index].classList.remove('hidden');
      var pct = ((index + 1) / totalSteps) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressText) progressText.textContent = (index + 1) + ' / ' + totalSteps;
    }

    function calcResult() {
      var total = scores.reduce(function(a, b) { return a + b; }, 0);
      if (total <= 9) return 5;
      if (total <= 12) return 1;
      if (total <= 15) return 2;
      if (total <= 19) return 3;
      return 4;
    }

    function showResult(resultIndex) {
      questionsWrap.classList.add('hidden');
      resultsWrap.classList.remove('hidden');
      var results = resultsWrap.querySelectorAll('.quiz__result');
      results.forEach(function(r) { r.classList.add('hidden'); });
      var target = resultsWrap.querySelector('[data-result="' + resultIndex + '"]');
      if (target) target.classList.remove('hidden');
      resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (startBtn) {
      startBtn.addEventListener('click', function() {
        intro.classList.add('hidden');
        questionsWrap.classList.remove('hidden');
        showStep(0);
      });
    }

    questionsWrap.addEventListener('click', function(e) {
      var opt = e.target.closest('.quiz__option');
      if (!opt) return;
      var val = parseInt(opt.dataset.value) || 1;
      scores[currentStep] = val;
      /* Highlight selected */
      var siblings = opt.parentElement.querySelectorAll('.quiz__option');
      siblings.forEach(function(s) { s.classList.remove('selected'); });
      opt.classList.add('selected');
      /* Auto-advance after short delay */
      setTimeout(function() {
        currentStep++;
        if (currentStep >= totalSteps) {
          var resultIdx = calcResult();
          showResult(resultIdx);
        } else {
          showStep(currentStep);
        }
      }, 400);
    });

    /* Email capture forms */
    resultsWrap.querySelectorAll('.quiz__email-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]').value;
        var resultType = form.dataset.resultType || '';
        if (!email) return;
        /* Submit to Shopify customer API */
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=✓&customer[email]=' + encodeURIComponent(email) + '&customer[tags]=' + encodeURIComponent('quiz,' + resultType)
        }).then(function() {
          form.innerHTML = '<p class="quiz__email-success">✓ ' + (window.Zelatonin.quizEmailSuccess || 'Check your inbox!') + '</p>';
        }).catch(function() {
          form.innerHTML = '<p class="quiz__email-success">✓ ' + (window.Zelatonin.quizEmailSuccess || 'Check your inbox!') + '</p>';
        });
      });
    });

    /* Share buttons */
    resultsWrap.addEventListener('click', function(e) {
      var shareBtn = e.target.closest('.quiz__share-btn');
      if (!shareBtn) return;
      var resultEl = shareBtn.closest('.quiz__result');
      var name = resultEl ? resultEl.querySelector('.quiz__result-name').textContent : '';
      var url = window.location.href;
      var text = (window.Zelatonin.quizShareText || "I'm {{name}}! Take the Zelatonin sleep quiz:").replace('{{name}}', name);
      var type = shareBtn.dataset.share;
      if (type === 'twitter') window.open('https://x.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url), '_blank');
      else if (type === 'facebook') window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
      else if (type === 'copy') {
        navigator.clipboard.writeText(url).then(function() {
          shareBtn.textContent = '✓';
          setTimeout(function() { shareBtn.textContent = '🔗'; }, 2000);
        });
      }
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initCountUp();
    initParticles();
    initParallax();
    initMarquee();
    initCartDrawer();
    initAgeGate();
    initMobileMenu();
    initFAQ();
    initProductForm();
    initSleepClockPill();
    initSleepQuiz();

    /* Convert country ISO codes to flag emojis */
    document.querySelectorAll('[data-country]').forEach(function(el) {
      var c = el.dataset.country;
      if (c && c.length === 2) {
        el.textContent = String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65, 0x1F1E6 + c.charCodeAt(1) - 65);
      }
    });
  });

  /* --- Shopify Theme Editor: re-init on section render --- */
  document.addEventListener('shopify:section:load', function() {
    initReveal();
    initCountUp();
    initFAQ();
    initProductForm();
    initSleepQuiz();
    initSleepClockPill();
  });

})();
